import { render, staticRenderFns } from "./TepSolicitudDetalle.vue?vue&type=template&id=70de18ea"
import script from "./TepSolicitudDetalle.vue?vue&type=script&lang=js"
export * from "./TepSolicitudDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports